import React from 'react';
import { useLocale } from '../i18n/LocaleContext';

export default function LocaleSwitch({ compact = false }) {
  const { locale, setLocale } = useLocale();

  return (
    <div
      className={`inline-flex items-center rounded-xl border border-[#D7DCE4] bg-white p-1 ${compact ? 'h-10' : ''}`}
      aria-label="Language"
      data-testid="locale-switch"
    >
      {[
        ['en', 'ENG'],
        ['cs', 'CZ'],
      ].map(([value, label]) => (
        <button
          key={value}
          type="button"
          onClick={() => setLocale(value)}
          className={`rounded-lg px-2 py-1 text-[11px] font-semibold transition ${
            locale === value ? 'bg-[#0B1D3A] text-white' : 'text-[#6B7280] hover:text-[#0B1D3A]'
          }`}
          aria-pressed={locale === value}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
